import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import t from '../Language/language'
import Api from '../../Api'
import requestIp from 'ip'
import { Config } from '../../Config'
import * as languageSettings from '../Language/languageSettings'
import AuthenticationService from '../Security/AuthenticationService'
import CommonLoader from '../Alerts/CommonLoader'
import { forgotPassword } from '../../actions/users'

import './ForgotPassword.css'
class ForgotPassword extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      currentLanguage: languageSettings.getCurrentLanguage(),
      isvalid: true,
      errorMessage: [],
      isSuccess: false,
      user_email_address: '',
      resetIP: requestIp.address() || '127.0.0.1',
      successMessage: '',
      successMessageDetail: '',
      showCommonLoader: false

    }
    this.api = new Api()
    this.authService = new AuthenticationService(Config.authBaseUrl)
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }
  // Handling input change and updating to state.
  handleChange (event) {
    let value = event.target.value
    this.setState({ user_email_address: value })
  }
  // Handling validation.
  handleValidation () {
    let language = this.state.currentLanguage
    let errors = []
    let email = (this.state.user_email_address).trim()
    if (email === '') {
      errors.push(t[language].emailblank)
    }
    if (email.length > 0) {
      let lastAtPos = email.lastIndexOf('@')
      let lastDotPos = email.lastIndexOf('.')

      if (!(lastAtPos < lastDotPos && lastAtPos > 0 && email.indexOf('@@') === -1 && lastDotPos > 2 && (email.length - lastDotPos) > 2)) {
        errors.push(t[language].emailinvalid)
      }
    }
    this.setState({ errorMessage: errors })
    if (errors.length > 0) {
      this.setState({ isvalid: false })
      return false
    }
    this.setState({ isvalid: true })
    return true
  }
  // Hanlding form submit.
  handleSubmit () {
    let errors = []
    let language = this.state.currentLanguage
    let resetIP = this.state.resetIP
    let resetAgent = navigator.userAgent
    if (this.handleValidation()) {
      this.setState({ showCommonLoader: true })
      // Preparing the post request data.
      const data = {
        User_EmailAddress: this.state.user_email_address,
        language: language,
        resetIP: resetIP,
        resetAgent: resetAgent
      }
      // Making redux action call.
      this.props.forgotPassword(data, result => {
        if (result.status) {
          this.setState({ showCommonLoader: false, isSuccess: true, successMessage: t[language].passResetSent, successMessageDetail: t[language].pleasecheckemailresetpass })
        } else {
          errors.push(t[language].emailinvalid)
          this.setState({ errorMessage: errors, showCommonLoader: false })
          if (errors.length > 0) {
            this.setState({ isvalid: false })
            return false
          }
        }
      })
    }
  }
  // Main render method.
  render () {
    let language = this.state.currentLanguage
    const populateError = (errors) => {
      return errors.map((error, i) => {
        return <li key={i}>{error}</li>
      })
    }
    return (
      <div id='forgotContent'>
        <div className='status-messages'>
          <div className={'alert alert-danger errors ' + (this.state.isvalid ? 'hide' : 'show')} >
            <ul> {populateError(this.state.errorMessage)}</ul>
          </div>
        </div>
        <div className={this.state.isSuccess ? 'show' : 'hide'}>
          <div className='forms clear'>
            <div className='appr' >
              <h3 style={{ 'fontSize': '24px' }}>{this.state.successMessage}</h3>
              <p style={{ 'fontSize': '14px' }}>{this.state.successMessageDetail}</p>
            </div>
          </div>
        </div>
        <section className={'report-container ' + (this.state.isSuccess ? 'hide' : 'show')}>
          {this.state.showCommonLoader ? <CommonLoader showLoader={this.state.showCommonLoader} message={'Loading...'} /> : ''}
          <div className='col1'>
            <div className={'forms ' + (this.state.showCommonLoader ? 'hide' : 'show')}>
              <table className='user_forgot_password'>
                <tbody>
                  <tr>
                    <th>
                      <label className='user_email_address_label' key='emailaddress'>{t[language].emailaddress}</label>
                    </th>
                    <td>
                      <input className='loginInputs' type='text' name='user_email_address' onChange={this.handleChange} />
                    </td>
                  </tr>
                  <tr>
                    <td />
                    <td>
                      <span className='btn_reset_password'>
                        <input type='submit' value={t[language].resetpassBtn} onClick={this.handleSubmit} translate='' key='resetpassBtn' />
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>
      </div>
    )
  }
}
// Updating the state from redux store.
function mapStateToProps (state) {
  return {
  }
}
// Binding the actions.
function matchDispatchToProps (dispatch) {
  return bindActionCreators(
    {
      forgotPassword: forgotPassword
    }, dispatch
  )
}
export default connect(mapStateToProps, matchDispatchToProps)(ForgotPassword)



// WEBPACK FOOTER //
// ./src/components/ForgotPassword/ForgotPassword.js